import React, { useEffect } from 'react';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';

const AccordionItem = ({ rendering, fields, openItems, handleOpenItem }) => {
  const open = openItems?.includes(rendering.uid) || false;

  useEffect(() => {
    if (fields.renderOpen?.value && !open) {
      handleOpenItem(rendering.uid);
    }
  }, []);

  const getIcon = () => {
    if (!fields.iconOpen?.value && !fields.iconClosed?.value) {
      return null;
    }
    if (fields.iconOpen?.value && fields.iconClosed?.value) {
      return (
        <div className="vds-accordion__icon" key={`${rendering.uid}_${open}`}>
          <i className={`fa-solid fa-${open ? fields.iconOpen.value : fields.iconClosed.value}`} />{' '}
        </div>
      );
    }
    return fields.iconOpen.value && fields.iconClosed.value;
  };
  return (
    <div
      className={`vds-accordion__item vds-accordion__item--${open ? 'open' : 'closed'}`}
      aria-expanded={open}
      data-testid={`${fields.testid?.value}-acc`}
    >
      <button
        className="vds-accordion__link"
        type="button"
        data-testid={fields.testid?.value}
        onClick={() => {
          handleOpenItem(rendering.uid);
        }}
      >
        {getIcon()}
        <Text
          tag="h3"
          className="vds-accordion__link-inner"
          field={fields.title}
          data-testid={`${fields.testid?.value}-title`}
        />
        <i className="vds-accordion__item-icon"></i>
      </button>
      <div
        className="vds-accordion__panel"
        aria-hidden="true"
        data-testid={`${fields.testid?.value}-panel`}
      >
        <div className="vds-accordion__panel-inner">
          <Placeholder name="accordion-content" rendering={rendering} />
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
